import React from 'react';
import { IconFileOff, IconPlus } from '@tabler/icons-react';
import { MButton } from '@/components/ui/atoms/MButtons';
import styles from '../dashboard.module.css';
import MSelectCard from '@/components/ui/atoms/MSelectCard';
import { useNavigate } from 'react-router-dom';

interface HealthEvent {
  id: string;
  title: string;
  source: string;
}

interface HealthEventsProps {
  year: number;
  events: HealthEvent[];
} 

const HealthEvents: React.FC<HealthEventsProps> = ({ year, events }) => {
  const navigate = useNavigate();
  const isEmpty = !events || events.length === 0;

  return (
    <>
      <div className={styles.ctaCardListTitle}>Health Events</div>
      <div
        className={styles.healthEventsCardWrapper}
        style={isEmpty ? {
          height: 274,
          background: '#fff',
          borderRadius: 24,
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)'
        } : { height: 'auto', background: 'none', borderRadius: 0, boxShadow: 'none' }}
      >
      {isEmpty ? (
        <div className={styles.dashboardCenter}>
          <IconFileOff size={64} color="#BCA7E6" className={styles.dashboardIcon} />
          <div className={styles.dashboardEmptyTitle}>
            No health events added for {year}
          </div>
          <MButton
            className={styles.dashboardButton}
            onClick={() => navigate(`/documents/health-memory/add?year=${year}`, { state: { backUrl: '/dashboard-detail' } })}
            leftIcon={<IconPlus size={28} />}
            size="md"
          >
            Add health memory
          </MButton>
        </div>
      ) : (
        <div className={styles.healthEventsList}>
          {events.map(event => (
            <MSelectCard
              key={event.id}
              text={event.title}
              description={event.source}
              variant="description"
              className={styles.healthEventCard}
            />
          ))}
        </div>
      )}
      </div>
    </>
  );
};

export default HealthEvents;
